const CHANNEL = require('./channel');
const CONVERSATION_EVENTS = require('./conversation-events');
const FEATURES = require('./features');
const MESSAGE = require('./message');
const INTEGRATION = require('./integration');

module.exports = {
  CHANNEL,
  CONVERSATION_EVENTS,
  FEATURES,
  MESSAGE,
  INTEGRATION,
};
